// Victory conditions (GDD §4.8): Control — hold a majority of Strategic Points to run
// down the enemy's ticket; and Annihilation — destroy all of a faction's structures.
// Control is the default and produces front-line games with comebacks. Ticket rate is
// the pacing knob (see WorldConfig.ticketDrainPerSec).

import type { Faction } from "./types";
import { World } from "./world";

export function stepVictory(world: World, dt: number): void {
  // Annihilation: a faction with no structures left is destroyed.
  for (const f of ["legion", "kindled"] as Faction[]) {
    if (world.structuresOf(f).length === 0) {
      declareWinner(world, world.enemyOf(f));
      return;
    }
  }

  // Control: majority point-holder drains the other's ticket.
  const tally = world.pointTally();
  const legionPts = tally.legion;
  const kindledPts = tally.kindled;
  if (legionPts !== kindledPts) {
    const majority: Faction = legionPts > kindledPts ? "legion" : "kindled";
    const minority = world.enemyOf(majority);
    const diff = Math.abs(legionPts - kindledPts);
    const drain = world.cfg.ticketDrainPerSec * (1 + (diff - 1) * 0.35);
    world.armies[minority].ticket -= drain * dt;
    if (world.armies[minority].ticket <= 0) {
      world.armies[minority].ticket = 0;
      declareWinner(world, majority);
    }
  }
}

function declareWinner(world: World, winner: Faction): void {
  if (world.phase !== "playing") return;
  world.winner = winner;
  world.phase = winner === world.cfg.playerFaction ? "won" : "lost";
}
